import React, { useEffect, useState } from "react";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import AddStaff from "../components/modals/AddStaff";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import {
  useDeleteStaffMutation,
  useGetStaffsQuery,
} from "../Redux/services/ClientAPis/staffApi";
import { formatDate, formatTime, success } from "../utils/helpers.js";
import RemoveModal from "../components/modals/RemoveModal";
import { useSelector } from "react-redux";
import ViewNotesModal from "../components/modals/ViewNotesModal.jsx";

const StaffManagement = () => {
  const [loading, setLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);
  const user = useSelector((state) => state.authInfo.user);
  const [taskView, setTaskView] = useState(false);
  const [taskModalData, setTaskModalData] = useState(null);
  const client_id = useSelector((state) => state.selectedData.value?.client_id);

  const { data, isLoading, refetch } = useGetStaffsQuery(
    {
      search: searchQuery.length >= 3 ? searchQuery : "",
      limit: pageSize,
      page: page,
      user_role: user?.user_type === "ADMIN" ? "admin" : "client",
      client_id: client_id?.value,
    },
    { refetchOnMountOrArgChange: true }
  );
  const [deleteStaff, { isLoading: deleteLoading }] = useDeleteStaffMutation();

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(
        data.links.total_records === 0 ? "" : data.links.total_records
      );
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const onRemoveClick = async () => {
    await deleteStaff({ id: modalData.id });
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  const header = [
    {
      title: "Staff Name",
      dataIndex: "name",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Email",
      dataIndex: "email",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Phone",
      dataIndex: "mobile_no",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },

    {
      title: "Designation",
      dataIndex: "designation",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    // {
    //   title: "Department",
    //   dataIndex: "department",
    //   style: { textAlign: "left" },
    //   elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    // },
    {
      title: "Date",
      dataIndex: "createdAt",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <p>{formatDate(rowData?.createdAt)}</p>;
      },
    },
    {
      title: "Notes",
      dataIndex: "notes",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "300px" },
      render: (_, rowData) => {
        return (
          <div
            className="cursor lc-2"
            onClick={() => {
              setTaskView(true);
              setTaskModalData(rowData);
            }}
            style={{ textDecoration: "none" }}
            onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
            onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
          >
            {rowData?.notes || "-"}
          </div>
        );
      },
    },
    {
      title: "Check In",
      dataIndex: "checkIn",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <p>{rowData?.attendance_logs[0]?.checkin_at || "-"}</p>;
      },
    },
    {
      title: "Check Out",
      dataIndex: "checkOut",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <p>{rowData?.attendance_logs[0]?.checkout_at || "-"}</p>;
      },
    },
    // {
    //   title: "Notes",
    //   dataIndex: "notes",
    //   style: { textAlign: "left" },
    //   elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    // },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     designation: "Physician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     designation: "Surgeon",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     designation: "Radiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     designation: "Neurologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     designation: "Physiotherapist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     designation: "Pediatrician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     designation: "Gynecologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     designation: "Anesthesiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     designation: "Pathologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     designation: "Oncologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //   },
  // ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);

  const onAddClick = () => {
    setAddOpen(true);
  };
  return (
    <div className="dashboard-page">
      <div className="header d-flex justify-content-between">
        <PageHeading text={"All Staff"} count={totalRecords} />
        <div className="d-flex responsive-flex align-items-center gap-3 ms-auto">
          {user?.user_type === "CLIENT" && (
            <ThemeAddButton
              text={"Add Staff"}
              onClick={onAddClick}
              className={"responsive-margin"}
            />
          )}
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
        </div>
      </div>
      <div className="table-content mt-2">
        <Table
          header={header}
          data={data?.data}
          loading={isLoading}
          removeText="Staff"
          onEditClick={() => setShowEdit(true)}
          setModalData={setModalData}
          setRemoveOpen={() => setRemoveOpen(true)}
          isAction={user?.user_type === "CLIENT"}
        />
      </div>
      <div className="pagination mt-3">
        {/* {!loading && ( */}
        <ThemePagination
          activePage={page}
          totalPages={totalPages}
          setPage={setPage}
          page={page}
        />
        {/* )} */}
      </div>
      {addOpen && (
        <ThemeModal
          size={"md"}
          modalContent={<AddStaff setIsOpen={setAddOpen} refetch={refetch} />}
          title={"Add Staff"}
          className={"edit-profile"}
          isOpen={addOpen}
          setIsOpen={setAddOpen}
        />
      )}
      {showEdit && (
        <ThemeModal
          size={"md"}
          modalContent={
            <AddStaff
              setIsOpen={setShowEdit}
              modalData={modalData}
              refetch={refetch}
            />
          }
          title={"Update Staff"}
          className={"edit-profile"}
          isOpen={showEdit}
          setIsOpen={setShowEdit}
        />
      )}
      {removeOpen && (
        <ThemeModal
          size={"sm"}
          modalContent={
            <RemoveModal
              setIsOpen={setRemoveOpen}
              modalData={modalData}
              refetch={refetch}
              onRemoveClick={onRemoveClick}
              isLoading={deleteLoading}
            />
          }
          title={""}
          className={"edit-profile"}
          isOpen={removeOpen}
          setIsOpen={setRemoveOpen}
        />
      )}
      {taskView && (
        <ThemeModal
          size={"lg"}
          modalContent={
            <ViewNotesModal setIsOpen={setTaskView} modalData={taskModalData} />
          }
          className={"edit-profile"}
          isOpen={taskView}
          setIsOpen={setTaskView}
        />
      )}
    </div>
  );
};

export default StaffManagement;
